const ProviderSchema = {
  id: 'ProviderSchema',
  type: 'object',
  required: [
    'nameProvider'
  ],
  properties: {
    nameProvider: {
      type: 'string',
      minLength: 4,
      maxLength: 50
    }
  }
};

export default ProviderSchema;
